import { render } from "./RecipesView.vue?vue&type=template&id=6bba7eef&scoped=true"
import script from "./RecipesView.vue?vue&type=script&lang=js"
export * from "./RecipesView.vue?vue&type=script&lang=js"

import "./RecipesView.vue?vue&type=style&index=0&id=6bba7eef&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bba7eef"]])

export default __exports__